export default "__VITE_ASSET__D7Ca$s5y__"